"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Burger = _interopRequireDefault(require("../../Icons/Burger"));

var _TouchableOpacity = _interopRequireDefault(require("../../TouchableOpacity"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Menu = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./Menu'));
  });
});

var Fallback = function Fallback() {
  var t = (0, _useTranslation.default)();
  return (0, _core.jsx)(_TouchableOpacity.default, {
    "aria-label": t('open_menu'),
    disabled: true
  }, (0, _core.jsx)(_Icon.default, {
    as: _Burger.default,
    color: "primary",
    size: 8
  }));
};

__signature__(Fallback, "useTranslation{t}", function () {
  return [_useTranslation.default];
});

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      breakpoint = _useTheme.breakpoint,
      spacing = _useTheme.spacing;

  return {
    root: (0, _defineProperty2.default)({
      height: spacing(7),
      alignItems: 'center',
      display: 'flex'
    }, breakpoint.up('lg'), {
      display: 'none'
    })
  };
};

__signature__(useStyles, "useTheme{{ breakpoint, spacing }}", function () {
  return [_useTheme2.default];
});

var Mobile = function Mobile(props) {
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, {
    css: classes.root,
    width: "100%",
    padding: [0, 2]
  }, (0, _core.jsx)(Menu, (0, _extends2.default)({
    fallback: (0, _core.jsx)(Fallback, null)
  }, props)));
};

__signature__(Mobile, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Mobile;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Menu, "Menu", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(Fallback, "Fallback", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(Mobile, "Mobile", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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